import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
// 3rd party libraries
import { type Observable } from 'rxjs'
// HUB libraries
import { HubConfigurationService } from '@inside-hub-app/hub-configuration'
// Feature
import type { CdbUserContextDto } from '../models'

@Injectable({ providedIn: 'root' })
export class UserPartnerContextClientService {
  private readonly http = inject(HttpClient)
  private readonly hubConfigurationService = inject(HubConfigurationService)

  private readonly apiUrl = this.hubConfigurationService.get<string>('api.pp-url')

  getUserContext (userId: number): Observable<CdbUserContextDto> {
    return this.http.get<CdbUserContextDto>(`${this.apiUrl}/cdb/user/user-context/${userId}`)
  }
}
